/* melco-header.js - behaviour for sections/melco-header.liquid */
(function () {
  if (window.__melcoHeaderBooted) return;
  window.__melcoHeaderBooted = true;

  /* ---- money formatting using the store's own format ---- */
  function formatMoney(cents, format) {
    format = String(format || '{{amount}}').replace(/<[^>]*>/g, '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re);
    var value;
    switch (m && m[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(re, value);
  }

  /* ---- shared: cart change detection (wraps fetch once) ---- */
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var p = origFetch.apply(this, args);
    try {
      var u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) {
        p.then(function () { document.dispatchEvent(new CustomEvent('melco:cart-changed')); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  /* ---- shared: wishlist store (localStorage). Heart buttons anywhere: <button data-wishlist-toggle="product-handle"> ---- */
  var WK = 'melco_wishlist';
  function readWish() {
    try {
      var v = JSON.parse(localStorage.getItem(WK) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function writeWish(v) {
    try { localStorage.setItem(WK, JSON.stringify(v)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('melco:wishlist:update', { detail: { items: v } }));
  }
  window.MelcoWishlist = {
    items: readWish,
    count: function () { return readWish().length; },
    has: function (h) { return readWish().indexOf(h) > -1; },
    toggle: function (h) {
      var v = readWish();
      var i = v.indexOf(h);
      if (i > -1) v.splice(i, 1); else v.push(h);
      writeWish(v);
      return i === -1;
    }
  };
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!t) return;
    e.preventDefault();
    var on = window.MelcoWishlist.toggle(t.getAttribute('data-wishlist-toggle'));
    t.setAttribute('aria-pressed', on);
    t.classList.toggle('is-active', on);
  });

  /* ---- per-header setup ---- */
  function init(root) {
    if (!root || root.dataset.melcoReady) return;
    root.dataset.melcoReady = '1';

    var ac = new AbortController();
    root.__melcoAbort = ac;
    var sig = { signal: ac.signal };

    var moneyFormat = root.dataset.moneyFormat;
    var searchUrl = root.dataset.searchUrl;
    var searchPage = root.dataset.searchPage;

    /* header height variables the theme reads */
    function setHeights() {
      document.body.style.setProperty('--header-height', root.offsetHeight + 'px');
      var group = document.getElementById('header-group');
      var total = 0;
      if (group) Array.prototype.forEach.call(group.children, function (el) { total += el.offsetHeight || 0; });
      document.body.style.setProperty('--header-group-height', total + 'px');
    }
    setHeights();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(setHeights);
      ro.observe(root);
      ac.signal.addEventListener('abort', function () { ro.disconnect(); });
    }

    /* cart count + total */
    function applyCart(cart) {
      root.querySelectorAll('[data-melco-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count; });
      root.querySelectorAll('[data-melco-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      root.querySelectorAll('[data-melco-cart-total]').forEach(function (el) {
        el.textContent = formatMoney(cart.total_price, moneyFormat);
      });
    }
    var cartTimer;
    function refreshCart() {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        origFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) { if (cart) applyCart(cart); })
          .catch(function () {});
      }, 150);
    }
    ['melco:cart-changed', 'cart:update', 'cart:added', 'cart:change', 'cart:updated'].forEach(function (name) {
      document.addEventListener(name, refreshCart, sig);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); }, sig);

    root.querySelectorAll('[data-melco-cart][data-drawer]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var d = document.getElementById('cart-drawer');
        var fn = d && (typeof d.open === 'function' ? d.open : typeof d.toggle === 'function' ? d.toggle : null);
        if (fn) {
          e.preventDefault();
          fn.call(d);
        }
      });
    });

    /* wishlist count */
    function paintWishlist() {
      var n = window.MelcoWishlist.count();
      root.querySelectorAll('[data-melco-wish-count]').forEach(function (el) { el.textContent = n; });
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (t) {
        var on = window.MelcoWishlist.has(t.getAttribute('data-wishlist-toggle'));
        t.setAttribute('aria-pressed', on);
        t.classList.toggle('is-active', on);
      });
    }
    paintWishlist();
    document.addEventListener('melco:wishlist:update', paintWishlist, sig);
    window.addEventListener('storage', paintWishlist, sig);

    /* search suggestions */
    var box = root.querySelector('[data-melco-search]');
    if (box) {
      var input = box.querySelector('input[type="search"]');
      var panel = box.querySelector('[data-melco-suggest]');
      var timer;
      var ctl;
      var hide = function () { panel.hidden = true; panel.textContent = ''; };
      var build = function (products, q) {
        panel.textContent = '';
        if (!products.length) {
          var empty = document.createElement('div');
          empty.className = 'melco-suggest__empty';
          empty.textContent = box.dataset.noResults + ' "' + q + '"';
          panel.appendChild(empty);
        }
        products.forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'melco-suggest__item';
          a.href = p.url;
          if (p.image) {
            var img = document.createElement('img');
            img.className = 'melco-suggest__img';
            img.alt = '';
            img.loading = 'lazy';
            img.width = 48;
            img.height = 48;
            img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96';
            a.appendChild(img);
          }
          var txt = document.createElement('span');
          var title = document.createElement('span');
          title.className = 'melco-suggest__title';
          title.textContent = p.title;
          txt.appendChild(title);
          if (p.price) {
            var price = document.createElement('span');
            price.className = 'melco-suggest__price';
            price.textContent = formatMoney(Math.round(parseFloat(p.price) * 100), moneyFormat);
            txt.appendChild(price);
          }
          a.appendChild(txt);
          panel.appendChild(a);
        });
        var all = document.createElement('a');
        all.className = 'melco-suggest__all';
        all.href = searchPage + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        all.textContent = box.dataset.viewAll;
        panel.appendChild(all);
        panel.hidden = false;
      };
      var run = function (q) {
        if (ctl) ctl.abort();
        ctl = new AbortController();
        var url = searchUrl + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
        origFetch(url, { signal: ctl.signal })
          .then(function (r) { if (!r.ok) throw new Error('suggest failed'); return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            build(products.map(function (p) {
              return { title: p.title, url: p.url, price: p.price, image: p.image };
            }), q);
          })
          .catch(function (err) { if (err.name !== 'AbortError') hide(); });
      };
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { if (ctl) ctl.abort(); hide(); return; }
        timer = setTimeout(function () { run(q); }, 250);
      });
      input.addEventListener('focus', function () { if (panel.childElementCount) panel.hidden = false; });
      document.addEventListener('click', function (e) { if (!box.contains(e.target)) panel.hidden = true; }, sig);
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { panel.hidden = true; input.focus(); }
      });
    }

    /* mobile drawer */
    var drawer = root.querySelector('[data-melco-drawer]');
    var opener = root.querySelector('[data-melco-open]');
    if (drawer && opener) {
      var panelEl = drawer.querySelector('.melco-drawer__panel');
      var focusable = 'a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])';
      var openDrawer = function () {
        drawer.inert = false;
        drawer.classList.add('is-open');
        opener.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('melco-lock');
        setTimeout(function () { panelEl.focus(); }, 30);
      };
      var closeDrawer = function () {
        if (!drawer.classList.contains('is-open')) return;
        drawer.classList.remove('is-open');
        drawer.inert = true;
        opener.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('melco-lock');
        opener.focus();
      };
      opener.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-melco-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (e.key === 'Escape') { closeDrawer(); return; }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(panelEl.querySelectorAll(focusable), function (el) { return el.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panelEl)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }, sig);
      var mq = window.matchMedia('(min-width: 990px)');
      if (mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) closeDrawer(); }, sig);
      ac.signal.addEventListener('abort', function () { document.documentElement.classList.remove('melco-lock'); });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-melco-header]').forEach(init);
  }

  initAll();
  /* theme editor: re-init when the section is re-rendered, clean up when removed */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-melco-header]').forEach(function (r) { if (r.__melcoAbort) r.__melcoAbort.abort(); });
  });
})();